import type { ElementType, ReactNode } from 'react';
import styles from './Container.module.css';

export interface ContainerProps {
  children: ReactNode;
  /** Element to render as — use `section`, `header`, `footer` etc. for landmarks. */
  as?: ElementType;
  /**
   * Widens past the reading measure, for a screen whose content is a dense
   * table. Prose stays at the narrower width, where the measure earns its
   * keep.
   */
  wide?: boolean;
  className?: string;
}

/**
 * Centres content at the design system's reading measure and owns the
 * responsive gutters. Layout primitive, not part of the source kit.
 *
 * <p>`wide` opts a screen out of that measure. A dense table is not prose and
 * does not benefit from it — held to 1200px, the blotter hid a third of itself
 * behind a horizontal scroll on a monitor with the room to show it.
 */
export function Container({ children, as: Tag = 'div', wide = false, className }: ContainerProps) {
  return (
    <Tag className={[styles.container, wide ? styles.wide : null, className]
      .filter(Boolean)
      .join(' ')}>
      {children}
    </Tag>
  );
}
